import { PIMIconButton } from './PIMIconButton';

export default PIMIconButton;
